<template>
    <div>
        <div class="leaderBox" v-if="showOrhide">
            <div class="newtext">新手指引</div>
            <img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
            <img src="../../assets/images/caigou1.png" class="steps step1" v-if="status==1">
            <img src="../../assets/images/caigou2.png" class="steps step2" v-if="status==2">
            <img src="../../assets/images/caigou3.png" class="steps step3" v-if="status==3">
            <div class="stepbtn" @click="nextStep(status)">
                {{status==1?"下一步":status==2?"下一步":status==3?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked">下次不再提示</el-checkbox>
            </div>
        </div>
        <breadcrumb :routerList="[{to:'/dingd/purchaselist',title:'订单管理'},{title:'采购订单审批'}]"/>

        <div class="h-content cgddthrids">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form
                                :model="zy"
                                label-position="right"
                                ref="form1"
                                :rules="rules"
                                :inline="true"
                                class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">


                                <div class="h-pieceIn2">
                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>基本信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine weekplandetail111">
                                            <el-form-item label="订单总价" class="h-elformWrap-2">
                                                <el-input readonly placeholder="自带出" v-model="zy.totalPrice"
                                                          type="number"></el-input>
                                            </el-form-item>
                                            <el-form-item label="期望到货时间" class="h-elformWrap-2" prop="expectDate">
                                                <div class="block">
                                                    <el-date-picker
                                                            v-model="zy.expectDate"
                                                            type="datetime"
                                                            placeholder="--选择--">
                                                    </el-date-picker>
                                                </div>
                                            </el-form-item>
                                            <el-form-item label="采购组" class="h-elformWrap-2" prop="cgGroupCode">
                                                <mdmselect
                                                        clearable
                                                        :showcode="true"
                                                        category="YLPurchaseGroup"
                                                        :v="zy.cgGroupCode"
                                                        v-model="zy.cgGroupCode">
                                                </mdmselect>
                                            </el-form-item>
                                            <el-form-item label="采购组织" class="h-elformWrap-2" prop="purchaseOrgCode">
                                                <brselect
                                                        clearable
                                                        category="purchase_org_code"
                                                        :v="zy.purchaseOrgCode"
                                                        v-model="zy.purchaseOrgCode">
                                                </brselect>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>


                                <div class="h-pieceIn2">
                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>物流信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine weekplandetail111">
                                            <el-form-item label="物流类型" class="h-elformWrap-2" prop="waybillType">
                                                <el-select
                                                        v-model="zy.waybillType"
                                                        placeholder="请选择">
                                                    <el-option
                                                            v-for="(item,index4) in options1"
                                                            :key="index4"
                                                            :label="item.name"
                                                            :value="item.code">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="接收人" class="h-elformWrap-2" prop="receiver">
                                                <el-input placeholder="请输入" v-model="zy.receiver"></el-input>
                                            </el-form-item>
                                            <el-form-item label="接收人手机号" class="h-elformWrap-2" prop="receverPhone">
                                                <el-input placeholder="请输入" v-model="zy.receverPhone"></el-input>
                                            </el-form-item>
                                            <el-form-item label="收货单位" class="h-elformWrap-2" prop="receiveUnit">
                                                <el-input placeholder="请输入" readonly v-model="zy.receiveUnit"></el-input>
                                            </el-form-item>
                                            <el-form-item label="收货地址" class="h-elformWrap-2" prop="detailAddress">
                                                <el-input clearable v-model="zy.detailAddress" readonly>
                                                    <i
                                                            class="el-icon-search el-input__icon"
                                                            slot="suffix"
                                                            @click="selectAreadialog">
                                                    </i>
                                                </el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>


                                <div class="N-chan">
                                    <div class="h-pieceTitle2">
                                        <h1>型号信息</h1>
                                    </div>
                                    <div class="yxtable ljjtable">
                                        <el-table
                                                ref="multipleTable"
                                                :data="tableData3"
                                                style="width: 100%"
                                                border
                                        >
                                            <el-table-column
                                                    type="index"
                                                    width="40"
                                                    label="#">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="productCate"
                                                    label="产品大类"
                                                    width="140">
                                                <template slot-scope="scope">

                                                    <el-select
                                                            v-model="scope.row.productCate"
                                                            placeholder="请选择"
                                                            disabled
                                                            filterable
                                                            @change="changeBig(scope.row)">
                                                        <el-option
                                                                v-for="(item,index) in productType"
                                                                :key="index"
                                                                :label="item.levelname"
                                                                :value="item.id">
                                                        </el-option>
                                                    </el-select>

                                                </template>

                                            </el-table-column>
                                            <el-table-column
                                                    prop="productDes"
                                                    label="产品型号"
                                                    width="240">
                                                <template slot-scope="scope">
                                                    <el-select
                                                            v-model="scope.row.productDes"
                                                            placeholder="请选择"
                                                            disabled
                                                            filterable
                                                            @change="changeSmail(scope.row,2)">
                                                        <el-option
                                                                v-for="(item,index2) in scope.row.productOptions"
                                                                :key="index2"
                                                                filterable
                                                                :label="item.levelname"
                                                                :value="item.levelname">
                                                        </el-option>
                                                    </el-select>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="productNo"
                                                    label="产品编码"
                                                    width="180">
                                                <template slot-scope="scope">
                                                    <el-select
                                                            v-model="scope.row.productNo"
                                                            placeholder="请选择"
                                                            disabled
                                                            filterable
                                                            @change="changeSmail(scope.row,1)">
                                                        <el-option
                                                                v-for="(item,index2) in scope.row.productOptions"
                                                                :key="index2"
                                                                filterable
                                                                :label="item.id"
                                                                :value="item.id">
                                                        </el-option>
                                                    </el-select>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                    prop="suserCode"
                                                    label="供应商名称"
                                                    min-width="240"
                                            >
                                                <template slot-scope="scope">

                                                    <el-select
                                                            style="width: 100%;"
                                                            v-model="scope.row.suserCode"
                                                            placeholder="请选择"
                                                            filterable
                                                            @change="changeSup(scope.row)">
                                                        <el-option
                                                                v-for="(item,index3) in scope.row.options2"
                                                                :key="index3"
                                                                :label="item.finalSupplierName"
                                                                :value="item.finalSupplier">
                                                        </el-option>
                                                    </el-select>

                                                </template>

                                            </el-table-column>
                                            <el-table-column
                                                    prop="unitPrice"
                                                    label="产品单价"
                                                    width="140">
                                                <template slot-scope="scope">
                                                    <el-input readonly placeholder="自带出"
                                                              v-model="scope.row.unitPrice"></el-input>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="count"
                                                    label="产品数量"
                                                    width="130">
                                                <template slot-scope="scope">


                                                    <el-input type="text" placeholder="请输入" v-model="scope.row.count"
                                                              maxlength="10" readonly
                                                              @change="changeNum(scope.row)"></el-input>

                                                </template>
                                            </el-table-column>


                                            <!--<el-table-column
                                                    label="操作"
                                                    width="100"
                                                    fixed="right"

                                            >
                                                <template slot-scope="scope">
                                                    <el-button type="text" size="small" class="h-tableLink h-btn"
                                                               @click="delPlan(scope.$index,scope.row)">删除
                                                    </el-button>
                                                    &lt;!&ndash; <div class="l-operationBox">
                                                        <span class="l-operationlist br-operation-delete" title="删除" @click="delPlan(scope.$index,scope.row)"></span>
                                                    </div> &ndash;&gt;
                                                </template>
                                            </el-table-column>-->
                                        </el-table>
                                        <!--<div class="h-tableAdd" @click="adds">
                                            <a>新增一行</a>
                                        </div>-->
                                    </div>
                                </div>


                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">返回</el-button>
<!--                <el-button class="h-btn h-bBtn h-bggreen" v-if="zy.status == 0 || zy.status ==''" class="h-btn h-bBtn h-bggreen" @click="save">暂存-->
<!--                </el-button>-->
                <el-button class="h-btn h-bBtn h-bgblueQ2" v-if="this.$route.query.taskstatus == 0"
                            @click="submit('form1')">提交
                </el-button>
            </div>
            <!--地址信息-->
            <areaSelect
                    :visible.sync="showdizhiflag"
                    v-if="showdizhiflag"
                    @choseObj="choseDizhi"
            />
        </div>


    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import big from 'big.js'
    import util from "../../utils/util";

    export default {
        data() {
            return {

                shenpixianshi: [],

                peizhi1: null,

                peizhi2: null,

                peizhi3: null,

                chakanyemian: false,

                yaoshanchude: [],

                tableData3: [],


                toshow: 'orderCreate',
                checked: true,
                showOrhide: false,
                status: 1,
                //带线表单
                value: false,
                newOrBid: true,
                options1: [{
                    code: '2',
                    name: '外部物流'
                }],
                options2: [],
                productOptions: [],
                productType: [],
                cgId: this.$route.query.cgId,
                ywId: this.$route.query.ywid,
                instId: this.$route.query.instid,
                ycId: this.$route.query.ycId,
                zy: {
                    numlist: null,
                    suserCode: '',
                    productCate: '',
                    type: '',
                    productNo: '',
                    waybillType: '',
                    unitPrice: '',
                    count: '',
                    totalPrice: '',
                    detailAddress: '',
                    expectDate: '',
                    productCateName: '',
                    productDes: '',
                    suserName: '',
                    status: 0,
                    proId: '',
                    cgGroupCode: '',
                    province: '',
                    city: '',
                    country: '',
                    purchaseOrgCode:""
                },
                rules: {
                    // suserCode: [
                    //     {required: true, message: '请选择供应商', trigger: 'change'}
                    // ],
                    // productCate: [
                    //     {required: true, message: '请选择产品大类', trigger: 'change'}
                    // ],
                    // productNo: [
                    //     {required: true, message: '请选择产品型号', trigger: 'change'}
                    // ],
                    waybillType: [
                        {required: true, message: '请选择物流类型', trigger: 'change'}
                    ],
                    // count: [
                    //     {required: true, message: '请输入产品数量', trigger: 'change'},
                    //     {pattern: /^[1-9]\d{0,9}$/, message: '请输入10位以内正整数'}
                    // ],
                    expectDate: [
                        {required: true, message: '请选择期货时间', trigger: 'change'},
                    ],
                    receiveUnit: [
                        {required: true, message: '请输入收货单位', trigger: 'blur'}
                    ],
                    receiver: [
                        {required: true, message: '请输入接收人', trigger: 'blur'}
                    ],
                    receverPhone: [
                        {required: true, message: '请输入接收人手机号', trigger: 'blur'},
                        {
                            pattern: /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/,
                            message: '请输入正确的手机号'
                        }
                    ],
                    detailAddress: [
                        {required: true, message: '请输入选择收货地址', trigger: 'input'}
                    ],
                    // unitPrice: [
                    //     {required: true, message: '产品单价根据产品型号带出不允许为空', trigger: 'blur'}
                    // ],
                    cgGroupCode: [
                        {required: true, message: '请选择采购组', trigger: 'blur'}
                    ],
                    purchaseOrgCode: [
                        {required: true, message: '请选择采购组织', trigger: 'blur'}
                    ],
                },
                vs: {
                    productId: ''
                },
                showdizhiflag: false,
                q: {
                    pageSize: 100,
                    pageNo: 1,
                    total: 0,
                    id: '',
                },
            }
        },

        created() {
            this.showzhezhao()


        },

        mounted() {

            //加载大类
            this.selectProduct1()

            //转发页加载
            this.zhuanfachushijiazai();

            // //外销预测信息加载
            // this.wxycload();

        },
        methods: {
            wxycload() {
                if (this.ycId!=null && this.ycId!='') {
                    this.q.id = this.ycId;
                    ss.waixiao.showDingdlist(this.q).then(rd => {
                        if (rd) {
                            if (rd.protype!=null && rd.protype=="OEM"){
                                var data = {
                                    "productCate":rd.cpdlName,
                                    "productNo":rd.proCode,
                                    "count":rd.proNumber,
                                    "productOptions":[{id:rd.proCode,levelname:rd.proModel}]
                                };
                                this.changeSmail(data,1);
                                this.tableData3.push(data);
                            }
                            // this.zy.expectDate = rd.deliveryDate+" 00:00:00";
                        }
                    })
                }
            },

            //小类修改，当块数据proProduct[i]-v
            changeSmail(v,flag) {

                v.unitPrice = '';
                this.zy.totalPrice = '';

                // this.options1 = [];
                v.proId = '';
                //设置产品型号名称
                if (flag == 1) {
                    v.productOptions.forEach((item, index) => {
                        if (v.productNo == item.id) {
                            v.productDes = item.levelname;
                        }
                    })
                } else if (flag == 2) {
                    v.productOptions.forEach((item, index) => {
                        if (v.productDes == item.levelname) {
                            v.productNo = item.id;
                        }
                    })
                }

                // //暂时注释掉获取单价接口
                // var data = {mdmMaterialInfoPrice: {materialid: v, leltypecode: 3}}
                // ss.ProService.product2Detail(data).then(rd => {
                //     if (rd.obj && rd.obj.length > 0) {
                //         this.zy.unitPrice = rd.obj[0].mdmMaterialInfoPrice.value;
                //     } else {
                //         this.zy.unitPrice = '';
                //     }
                // })
                v.options2 = [];
                v.suserCode = '';
                v.suserName = '';
                this.vs = {};
                //获取供应商列表
                if (v.productNo) {
                    this.vs.productId = v.productNo;
                    ss.ProService.supplierByProductId(this.vs).then(rd => {
                        if (rd && rd.length > 0) {
                            //供应商信息
                            v.options2 = rd;
                            // rd.forEach((item, index) => {
                            //     v.options2.push(item);
                            // })
                            v.options2.forEach((item, index) => {
                                var canshu = {
                                    suserCode: item.finalSupplier,
                                    productNo: v.productNo
                                };
                                // canshu.suserCode = item.finalSupplier;
                                // canshu.productNo = v.productNo;
                                //查询供应商商品占比
                                // selectProSupplier(x) {
                                //     this.proSupplier = {};
                                ss.orderCgService.selectProSupplier(canshu).then(rm => {
                                    console.log('我在这儿呀111', rm);
                                    if (rm) {
                                        //item.finalSupplierName = item.finalSupplierName + ',产品供应量占比: ' + rm.proportion;
                                    }
                                })
                                // },;
                            })
                            console.log('我在这儿呀000', v.options2);
                            console.log("嗯嗯???");

                            this.$set(v.options2, rd);
                        }
                    })
                }
                return v;
            },
            //供应商名字
            changeSup(v) {
                v.options2.forEach((item, index) => {
                    if (v.suserCode == item.finalSupplier) {
                        v.suserName = item.finalSupplierName;
                        v.unitPrice = item.unitPrice;
                        v.proId = item.contractId;
                        // if (item.wuliufangshi == 3) {
                        //     this.options1 = this.$store.getters.dicts["waybill_type"];
                        // }else{
                        //     console.log(this.$store.getters.dictname("waybill_type",item.wuliufangshi))
                        //     this.options1 = [{"code": item.wuliufangshi,"name":this.$store.getters.dictname("waybill_type",item.wuliufangshi)}];
                        // }
                    }
                })
				var total= 0;
				for(var i = 0;i < this.tableData3.length; i++){
				    var data = this.tableData3[i];
				    if(data.count && data.unitPrice){
				        total=new big(data.unitPrice).times(data.count).plus(total);
				    }
				}
				console.log(total.toString());
				this.zy.totalPrice = total.toString();
            },


            showzhezhao() {
                ss.salesList.toshow(this.toshow).then(rd => {
                    console.log(rd)
                    if (rd == false) {
                        this.showOrhide = false;
                    } else {
                        this.showOrhide = true;
                    }
                })
            },
            //转发加载
            zhuanfachushijiazai() {

                if (this.cgId != null || (this.ywId != null && this.instId != null)) {

                    // var yewuid = this.cgId != null ? this.cgId : this.ywId;
                    var yewuid = '';
                    if (this.cgId) {
                        yewuid = this.cgId;
                    } else if (this.ywId) {
                        yewuid = this.ywId
                    }

                    //查看订单详情
                    ss.orderCgService.appselectById(yewuid).then(rd => {

                        console.log(rd.obj, 'rd.obj')

                        if (rd.obj) {

                            //加载自己信息
                            this.jiazaiobjxinxi(rd.obj);

                            // 若兄弟信息存在
                            if (rd.obj.orderCgList) {

                                //加载兄弟信息
                                // this.jiazaixiongdi(rd.obj.orderCgList);

                                this.xindejiazai(rd.obj.orderCgList);
                                console.log(this.tableData3,"..................");

                            }

                        }

                    })


                }

            },


            //加载当前自己的原始信息
            jiazaiobjxinxi(q) {

                //初始化默认数据
                this.zy = q;
                console.log(this.zy);

                // var data = {
                //     "productCate":q.productCate,
                //     "productNo":q.productNo,
                //     "count":q.count,
                //     "productOptions":[{id:q.productNo,levelname:q.productDes}]
                // };
                // this.changeSmail(data,1);
                // this.tableData3.push(data);

            },

            xindejiazai(cgli) {
				console.log(cgli,"//././././././.")
                for (var i = 0; i < cgli.length; i++) {
                    console.log(cgli[i],"shaa ");
                    var data = cgli[i];
                    data['productOptions'] = [{id:cgli[i].productNo,levelname:cgli[i].productDes}]
                    // var data = {
					// 	"productCateName":cgli[i].productCateName,
                    //     "productCate":cgli[i].productCate,
                    //     "productNo":cgli[i].productNo,
                    //     "count":cgli[i].count,
                    //     "productOptions":[{id:cgli[i].productNo,levelname:cgli[i].productDes}]
                    // };
                    // console.log(data,"/////");
                    this.changeSmail(data,1);
					this.tableData3.push(data);
                }
                this.tableData3.sort();
                this.selectProduct1();
				console.log(this.tableData3,"我看看还有什么");
            },

            // //加载兄弟信息
            // jiazaixiongdi(q) {
            //
            //     var orderCg = {
            //
            //         instidlist: [],
            //         taskId: this.$route.query.taskid,
            //
            //     };
            //
            //     for (var s in q) {
            //
            //         this.adds();
            //
            //         orderCg.instidlist.push(q[s].instid)
            //
            //     }
            //
            //
            //     console.log(orderCg, '入参')
            //
            //     ss.orderCgService.shuaixuanInstid(orderCg).then(rd => {
            //
            //         console.log(rd, '可以显示的，需要审批的')
            //
            //         //过滤存在
            //         if (JSON.stringify(rd.obj) != '{}' && this.$route.query.taskid) {
            //
            //             this.shenpixianshi = rd.obj;
            //
            //             var qq = [];
            //
            //             for (var c in q) {
            //
            //                 for (var d in rd.obj) {
            //                     console.log(rd.obj[d],"你是谁");
            //                     if (q[c].instid == rd.obj[d]) {
            //
            //                         qq.push(q[c])
            //
            //                     }
            //
            //                 }
            //
            //             }
            //
            //             this.tableData3 = [];
            //
            //             for (var c in qq) {
            //
            //                 this.tableData3[c] = qq[c];
            //
            //             }
            //
            //         } else {
            //
            //             for (var c in q) {
            //
            //                 this.tableData3[c] = q[c];
            //
            //             }
            //
            //         }
            //
            //         var total=0;
            //         for(var i=0;i<this.tableData3.length;i++){
            //             var data = this.tableData3[i];
            //             if(data.count && data.unitPrice){
            //                 total=new big(data.unitPrice).times(data.count).plus(total);
            //             }
            //         }
            //         this.zy.totalPrice = total;
            //
            //         for (var m in this.tableData3) {
            //
            //
            //             this.tableData3[m].productOptions = this.tableData3[m].product2OemSelectresult;
            //
            //
            //             for (var d in this.tableData3[m].productType) {
            //
            //                 if (d == 'id' && this.tableData3[m].productCate == d) {
            //
            //                     this.tableData3[m].productCateName = this.tableData3[m][d].levelname;
            //
            //                 }
            //
            //             }
            //
            //
            //             this.tableData3[m].productOptions = this.tableData3[m].product2Selectresult;
            //
            //             if (this.tableData3[m].productOptions) {
            //                 //设置产品型号名称
            //                 this.tableData3[m].productOptions.forEach((item, index) => {
            //                     if (this.tableData3[m].productNo == item.id) {
            //                         this.tableData3[m].productDes = item.levelname;
            //                     }
            //                 })
            //             }
            //
            //             this.vs.productId = this.tableData3[m].productNo;
            //
            //
            //             this.tableData3[m].options2 = this.tableData3[m].supplierByProductIdresult;
            //
            //
            //         }
            //
            //
            //     })
            //
            //
            // },


            //清空选择型号
            qingkong() {

                this.$msg.confirm("确认清空？", () => {

                    this.f.numlist = null;

                })

            },


            //删除框
            delPlan(index, q) {

                console.log(q, 'qaaaaa')

                this.$confirm('确认删除？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				})
                    .then(_ => {

                        //如果原来有数据
                        if (q.id != null) {//把要删除的主键id存起来
                            this.yaoshanchude.push({id: q.id});


                        }
                        this.tableData3.splice(index, 1)
                        //console.log(index,"删除一行数据");

                    })
                    .catch(_ => {

                    });

            },


            // //增加行
            // adds() {
            //
            //     var list = {
            //
            //         productCateName: '',
            //         productDes: '',
            //         productCate: '',
            //         productNo: '',
            //         productOptions: [],
            //         suserCode: '',
            //         suserName: '',
            //         options2: [],
            //         unitPrice: '',
            //         count: '',
            //         proId: '',
            //
            //     }
            //
            //
            //     this.tableData3.push(list)
            //
            // },


            closeIt() {
                this.showOrhide = false;
                if (this.checked) {
                    ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                        console.log(rd)
                        this.showOrhide = false;
                    })
                } else {
                    ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                        console.log(rd)
                        this.showOrhide = false;
                    })
                }
            },
            nextStep(i) {
                console.log(i)
                if (this.status == 1) {
                    document.documentElement.scrollTop = 200;
                } else if (this.status == 2) {
                    this.status = 3;
                } else if (this.status == 3) {
                    if (this.checked) {
                        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                            console.log(rd)
                            this.showOrhide = false;
                        })
                    } else {
                        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                            console.log(rd)
                            this.showOrhide = false;
                        })
                    }

                }
            },

            // //采购组
            // changeGroup(v) {
            //
            //     this.optionLists.forEach((item,index) => {
            //         if (v == item.code) {
            //             this.zy.cgGroupName = item.name;
            //         }
            //     })
            //
            // },
            //产品大类下拉框
            selectProduct1() {
                ss.ProService.product1Select().then(rd => {
                    this.productType = rd;
                })
            },


            //大类修改时，当块数据proProduct[i]-v,index-i
            changeBig(v) {

                v.productNo = '';
                v.unitPrice = '';
                v.count = '';
                v.productCateName = '';
                v.productDes = '';
                v.options2 = [];
                v.suserCode = '';
                v.suserName = '';
                v.proId = '';

                this.zy.totalPrice = '';

                this.productType.forEach((item, index) => {
                    if (v.productCate == item.id) {
                        v.productCateName = item.levelname;
                    }
                })

                // this.options1 = [];

                this.selectProduct2(v);

            },


            //大类修改时，查询小类列表 v.type大类id-v,index-i
            selectProduct2(v) {
                ss.ProService.product2OemSelect(v.productCate).then(rd => {
                    v.productOptions = rd;
                    this.$set(v.productOptions, rd);
                })
            },


            changeNum(v) {
                var total=0;
                for(var i=0;i<this.tableData3.length;i++){
                    var data = this.tableData3[i];
                    if(data.count && data.unitPrice){
                        total=new big(data.unitPrice).times(data.count).plus(total);
                    }
                }
                this.zy.totalPrice = total.toString();
            },
            cancel() {
                this.$router.push("purchaselist");
            },


            submit(form) {
                var flag = false;
                this.$refs[form].validate((valid) => {
                    if (valid) {
                        flag = true;
                    } else {
                        return false;
                    }
                });
                if (flag) {
                    //判断数据完整
                    if (this.shoudongpanduan()) {

                        this.$msg.msge("请先填写完整产品信息并保证信息准确性")

                    } else {

                        this.newtijiao();

                    }
                }

            },


            //手动判断
            shoudongpanduan() {

                var s = false;

                for (var c in this.tableData3) {

                    if (

                        (this.tableData3[c].productCate == null || this.tableData3[c].productCate == '') ||
                        (this.tableData3[c].suserCode == null || this.tableData3[c].suserCode == '') ||
                        (this.tableData3[c].productNo == null || this.tableData3[c].productNo == '') ||
                        (this.tableData3[c].count == null || this.tableData3[c].count == '') ||
                        (this.tableData3[c].unitPrice == null || this.tableData3[c].unitPrice == '')

                    ) {

                        s = true;

                    } else {

                        let ex = /^[1-9]\d{0,9}$/
                        if (!ex.test(this.tableData3[c].count)) {
                            s = true;
                        }

                    }


                }

                return s;

            },


            //构造参数
            gouzaocanshu() {

                var entitylist = [];

                for (var c in this.tableData3) {

                    entitylist.push({

                        numlist: this.zy.numlist,
                        type: this.zy.type,
                        waybillType: this.zy.waybillType,
                        detailAddress: this.zy.detailAddress,
                        expectDate: this.zy.expectDate,
                        status: this.zy.status,
                        cgGroupCode: this.zy.cgGroupCode,
                        purchaseOrgCode: this.zy.purchaseOrgCode,
                        province: this.zy.province,
                        city: this.zy.city,
                        country: this.zy.country,
                        receiver: this.zy.receiver,
                        receverPhone: this.zy.receverPhone,
                        receiveUnit: this.zy.receiveUnit,


                        instid: this.instId || null,
						orderId:this.tableData3[c].orderId || '',
						orderCode:this.tableData3[c].orderCode || '',
                        cgId: this.tableData3[c].cgId || '',
                        zhubiaoid: this.tableData3[c].zhubiaoid || '',
                        productCateName: this.tableData3[c].productCateName,
                        productDes: this.tableData3[c].productDes,
                        productCate: this.tableData3[c].productCate,
                        productNo: this.tableData3[c].productNo,
                        suserCode: this.tableData3[c].suserCode,
                        suserName: this.tableData3[c].suserName,
                        unitPrice: this.tableData3[c].unitPrice,
                        count: this.tableData3[c].count,
                        proId: this.tableData3[c].proId,
                        totalPrice: (new big(parseFloat(this.tableData3[c].unitPrice)).times(parseInt(this.tableData3[c].count))).toString(),

                    })

                }

                return entitylist;

            },


            //新list提交方法
            newtijiao() {
                // var flag = false;
                // this.$refs['form1'].validate((valid) => {
                //     if (valid) {
                //         flag = true;
                //     } else {
                //         this.$msg.msge("请完善采购订单数据！");
                //         return false;
                //     }
                // });
                // if (!flag) {
                //     return;
                // }
                this.changeNum();
                this.zy.expectDate = util.riQi6(this.zy.expectDate)

                // //审批驳回提交
                // if (this.ywId != null && this.instId != null) {
                //     ss.orderCgService.renewOrderCglist(this.gouzaocanshu()).then(rd => {
                //         if (rd.f) {
                //             this.$msg.msgs("提交成功！");
                //             this.$store.dispatch('searchTasktotal');
                //             this.$router.push("purchaselist");
                //         } else {
                //             this.$msg.msge("提交失败！" + rd.msg);
                //         }
                //     })
                //
                //     //普通提交
                // } else {
                console.log(this.tableData3,".,.,.,.,.,.,.,.,");
                console.log(this.zy,"我看看要提交啥");
                this.zy.status = 1;
                var entitylist = this.gouzaocanshu();
                console.log("你是处理好的数据???",entitylist);
                ss.orderCgService.insertOEMlist(entitylist).then(rd => {
                    if (rd.f) {
                        this.$msg.msgs("提交成功！");
                        this.$router.push("purchaselist");
                    } else {
                        this.$msg.msge("提交失败！" + rd.msg);
                    }
                })
                // }
            },


            //旧蔡工单提交方法
            oldtijiao() {
                var flag = false;
                this.$refs['form1'].validate((valid) => {
                    if (valid) {
                        flag = true;
                    } else {
                        this.$msg.msge("请完善采购订单数据！");
                        return false;
                    }
                });
                if (!flag) {
                    return;
                }
                this.zy.expectDate = util.riQi6(this.zy.expectDate)

                //审批提交
                if (this.ywId != null && this.instId != null) {
                    ss.orderCgService.renewOrderCg(this.zy).then(rd => {
                        if (rd.f) {
                            this.$msg.msgs("提交成功！");
                            this.$store.dispatch('searchTasktotal');
                            this.$router.push("purchaselist");
                        } else {
                            this.$msg.msge("提交失败！" + rd.msg);
                        }
                    })

                    //普通提交
                } else {
                    this.zy.status = 1;
                    ss.orderCgService.createCgOrder(this.zy).then(rd => {
                        if (rd.f) {
                            this.$msg.msgs("提交成功！");
                            this.$router.push("purchaselist");
                        } else {
                            this.$msg.msge("提交失败！" + rd.msg);
                        }
                    })
                }
            },

            //暂存
            save() {

                this.savenew();

            },


            //新暂存list
            savenew() {

                this.zy.status = 0;
                if (this.zy.expectDate) {
                    this.zy.expectDate = util.riQi6(this.zy.expectDate)
                }
                ss.orderCgService.createCgOrderlist(this.gouzaocanshu()).then(rd => {
                    if (rd.f) {
                        this.$msg.msgs("提交成功！");
                        this.$router.push("purchaselist");
                    } else {
                        this.zy.status = "";
                        this.$msg.msge("提交失败！" + rd.msg);
                    }
                })

            },


            //旧蔡工单暂存
            saveold() {

                this.zy.status = 0;
                if (this.zy.expectDate) {
                    this.zy.expectDate = util.riQi6(this.zy.expectDate)
                }
                ss.orderCgService.createCgOrder(this.zy).then(rd => {
                    if (rd.f) {
                        this.$msg.msgs("提交成功！");
                        this.$router.push("purchaselist");
                    } else {
                        this.$msg.msgs("提交失败！" + rd.msg);
                    }
                })

            },


            choseDizhi(obj) {
                // this.zy.detailAddress = obj.quobj.namepath;
                if (obj.zhenobj) {
                    // this.zy.detailAddress = obj.zhenobj.namepath;
					this.$set(this.zy, "detailAddress", obj.zhenobj.namepath)
                }
                // this.zy.detailAddress = this.zy.detailAddress + obj.addrdetail;
				this.$set(this.zy, "detailAddress", this.zy.detailAddress + obj.addrdetail)
                this.zy.province = obj.shengobj.name;
                this.zy.city = obj.shiobj.name;
                this.zy.country = obj.quobj.name;
                // this.order.addressCode = obj.id;
                // this.order.areaId = obj.id;
                // this.order.toAddress = obj.quobj.namepath;
                // if(obj.zhenobj){
                //     this.order.toAddress = obj.zhenobj.namepath;
                // }
                // this.order.toAddress = this.order.toAddress + obj.addrdetail
                // this.order.toProvincesCode = obj.shengobj.name;
                // this.order.toCityCode = obj.shiobj.name;
                this.showdizhiflag = false;
            },
            //选择地址
            selectAreadialog() {
                this.showdizhiflag = true;
            },
        },

    }
</script>
<style>
    .h-formbLine .weekplandetail111 .el-form-item__label {
        width: 35%;
        text-align: right;
    }

    .h-formbLine .weekplandetail111 .el-form-item__content {
        width: 65%;
    }

    .h-formbLine .weekplandetail111 .h-elformWrap-2 {
        width: 33.333%!important;
        padding-right: 0.5rem
    }

    .h-formbLine .weekplandetail111 .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .h-formbLine .weekplandetail111 .h-elformWrap-1 .el-form-item__label {
        width: 9.7%;
    }

    .h-formbLine .weekplandetail111 .h-elformWrap-1 .el-form-item__content {
        width: 90.3%;
    }
</style>
<style scoped lang="scss">
    .bottomTip {
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
    }

    .newtext {
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top: 0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow: 1px 1px 4px #2785E7;
        z-index: 2;
    }

    .leaderBox {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;

    .leaderbg {
        width: 100%;
        height: 100%;

    }

    .steps {
        position: absolute;
        z-index: 1;

    }

    .step1 {
        top: 2.1rem;
        left: 3.3rem;
        width: 15rem;
        height: 2rem;
    }

    .step2 {
        top: 6.9rem;
        right: 7.8rem;
        width: 4.4rem;
        height: 1rem;
    }

    .step3 {
        top: 6.9rem;
        right: 2.9rem;
        width: 1.9rem;
        height: 1rem;
    }

    .stepbtn {
        width: 1.9rem;
        height: 0.6rem;
        border: 0.03rem solid #FFFFFF;
        background-color: rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        display: flex;
        justify-content: center;
        line-height: 0.5rem;
        position: absolute;
        z-index: 99;
        bottom: 0.75rem;
        left: 50%;
        transform: translateX(-50%);
        font-size: 0.27rem;
        letter-spacing: 2px;
        color: white;
        cursor: pointer;
    }

    .closeIt {
        width: 0.3rem;
        height: 0.3rem;
        position: absolute;
        top: 0.2rem;
        right: 0.2rem;
        cursor: pointer;
    }
    }
</style>

